import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13 5.83L15.59 8.41L17 7L12 2L7 7L8.41 8.41L11 5.83V22H13V5.83Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LongUp"
);
